import { Inject, Injectable, Optional } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { Observable } from 'rxjs';

import { SVG_ICON_CONFIG, SvgIconConfig } from './svg-icon-config.token';

@Injectable({
    providedIn: 'root'
})
export class SvgIconService {
    public svgIconMap: Map<string, Observable<SafeHtml>> = new Map<string, Observable<SafeHtml>>();
    public useIonIconComponent: boolean = false;
    public sharedComponentsIconAssetPath = '../../../assets/svg-icons/';
    private iconAssetPath: string = '/icons/svg/';
    private iconFileNamesObject: { [key: string]: string } = {};

    constructor(@Optional() @Inject(SVG_ICON_CONFIG) config?: SvgIconConfig) {
        if (config) {
            this.iconAssetPath = config.iconAssetPath;
            this.iconFileNamesObject = config.iconFileNamesObject;
            this.useIonIconComponent = config.useIonIconComponent;
        }
    }

    setUseIonIconComponent(useIonIcon: boolean) {
        this.useIonIconComponent = useIonIcon;
    }

    getUseIonIconComponent() {
        return this.useIonIconComponent;
    }

    setIconAssetPath(path: string) {
        this.iconAssetPath = path;
    }

    getIconAssetPath() {
        return this.iconAssetPath;
    }

    setIconFileNamesObject(object: { [key: string]: string }) {
        this.iconFileNamesObject = object;
    }

    getIconFileNameObject() {
        return this.iconFileNamesObject;
    }

    getIconFileNameFromObject(iconName: string) {
        return this.iconFileNamesObject[iconName] || null;
    }
}
